import * as tslib_1 from "tslib";
import { EventEmitter, OnDestroy, OnInit } from '@angular/core';
var PhotoFeedbackGalleryComponent = /** @class */ (function () {
    function PhotoFeedbackGalleryComponent() {
        this.onClose = new EventEmitter();
        this.currentIndex = 0;
        this.showSidepanel = false;
        this.keyListener = function (event) { };
    }
    PhotoFeedbackGalleryComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.currentIndex = this.data.selectedIndex || 0;
        setTimeout(function () {
            _this.showSidepanel = true;
        });
        this.keyListener = function (event) {
            if (!_this.data.images || !_this.data.images.length)
                return;
            if (event.key === 'ArrowRight') {
                _this.showNextImage();
            }
            if (event.key === 'ArrowLeft') {
                _this.showPreviousImage();
            }
            // Keep these keys from scrolling the panel behind the gallery
            if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown'].indexOf(event.key) !== -1) {
                event.preventDefault();
            }
        };
        window.addEventListener('keydown', this.keyListener);
    };
    PhotoFeedbackGalleryComponent.prototype.ngOnDestroy = function () {
        // Always unlock the base side panel, whichever way the gallery got closed
        var basePanel = document.getElementById('side-panel');
        if (basePanel) {
            basePanel.classList.remove('pfg-base-blocked');
        }
        window.removeEventListener('keydown', this.keyListener);
    };
    PhotoFeedbackGalleryComponent.prototype.openImage = function (index) {
        this.currentIndex = index;
    };
    PhotoFeedbackGalleryComponent.prototype.close = function () {
        this.onClose.emit();
    };
    PhotoFeedbackGalleryComponent.prototype.onPanelClose = function () {
        this.close();
    };
    PhotoFeedbackGalleryComponent.prototype.showNextImage = function () {
        if (!this.data.images || !this.data.images.length)
            return;
        this.currentIndex = (this.currentIndex + 1) % this.data.images.length;
    };
    PhotoFeedbackGalleryComponent.prototype.showPreviousImage = function () {
        if (!this.data.images || !this.data.images.length)
            return;
        this.currentIndex = (this.currentIndex - 1 + this.data.images.length) % this.data.images.length;
    };
    PhotoFeedbackGalleryComponent.prototype.downloadImg = function (imageSrc) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var image, imageBlob, imageURL, link;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(imageSrc)];
                    case 1:
                        image = _a.sent();
                        return [4 /*yield*/, image.blob()];
                    case 2:
                        imageBlob = _a.sent();
                        imageURL = URL.createObjectURL(imageBlob);
                        link = document.createElement('a');
                        link.href = imageURL;
                        link.download = imageSrc.split('/').pop();
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        return [2 /*return*/];
                }
            });
        });
    };
    return PhotoFeedbackGalleryComponent;
}());
export { PhotoFeedbackGalleryComponent };
